export enum ContentType {
  FORM = 'application/x-www-form-urlencoded',
  JSON = 'application/json; charset=utf-8',
  TEXT = 'text/html; charset=utf-8'
}
